import React, { useMemo } from 'react'

import {
  AdvancedQuestionConfiguration,
  MarkerConfiguration,
  OptionConfiguration,
  QuestionConfiguration,
  QuestionGeneration,
  Questionnaire,
  TemplateConfiguration,
} from './index'
import { classes } from '../index'
import IntegrationConfig from './IntegrationConfig'
import ParagraphConfiguration from './ParagraphConfig'
import QuestionGroupConfig from './QuestionGroupConfig'
import QuestionConditionalConfiguration from './QuestionConditionals'

const getConfigurationComponent = (keystring, id) => {
  switch (keystring) {
    case 'template':
      return <TemplateConfiguration />
    case 'integration':
      return <IntegrationConfig key={id} id={id} />
    case 'template-creation':
      return <QuestionGeneration />
    case 'question-group':
      return <QuestionGroupConfig id={id} />
    case 'question':
      return <QuestionConfiguration key={id} id={id} />
    case 'question-conditional':
      return <QuestionConditionalConfiguration key={id} id={id} />
    case 'question-advanced':
      return <AdvancedQuestionConfiguration id={id} />
    case 'option':
      return <OptionConfiguration key={id} id={id} />
    case 'marker':
      return <MarkerConfiguration key={id} id={id} />
    case 'document-generation':
      return <Questionnaire />
    case 'paragraph':
      return <ParagraphConfiguration key={id} id={id} />
    default:
      return null
  }
}

const ConfigEntry = React.memo(props => {
  const { keystring, id } = props
  const render = useMemo(() => getConfigurationComponent(keystring, id), [keystring, id])
  return <div className={classes.configEntry.wrapper}>{render}</div>
})

ConfigEntry.displayName = 'Wizard-Configuration-ConfigEntry'

export default ConfigEntry
